import React, { useCallback } from 'react';
import { View } from 'react-native';
import Animated from 'react-native-reanimated';
import { AppView, Button, CardView, SCREEN_BOTTOM_PADDING, SCROLL_INDICATOR_INSETS, Spacer, rem, withAnimatedNavigationHeader, } from 'design-system';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { useMarginBottom } from 'hooks/useMarginBottom';
import Logo from 'design-system/Logo';
import Text from 'design-system/Text';
import createStyleSheets from 'utils/createStyleSheets';
import useStyles from 'hooks/useStyles';
import links from 'utils/links';
import { selectFeatureFlag } from 'reducers/selectors';
import { useAppSelector } from 'store/hooks';
import { isWeb } from '../../../../constants';
const keyExtractor = (item) => item.id.toString();
const CurrentAccountSwitchOffers = withAnimatedNavigationHeader(({ navigation, scrollHandler }) => {
    const { extra } = useAppSelector((store) => selectFeatureFlag(store, 'current_account_switch_offers'));
    const offers = extra?.offers;
    const renderItem = useCallback(({ item }) => (<Card item={item} onPressMoreDetails={() => navigation.navigateDeprecated('CurrentAccountSwitchOffer', item)} onGetOffer={() => links.openLink(item.link)}/>), []);
    const { paddingHorizontalStyle } = useAppFrameDimensions(isWeb);
    const contentContainerStyle = useMarginBottom('paddingBottom', SCREEN_BOTTOM_PADDING, paddingHorizontalStyle);
    return (<AppView withFrame={false}>
          <Animated.FlatList data={offers} initialNumToRender={4} renderItem={renderItem} scrollIndicatorInsets={SCROLL_INDICATOR_INSETS} keyExtractor={keyExtractor} onScroll={scrollHandler} contentContainerStyle={contentContainerStyle}/>
        </AppView>);
}, ({ colors }) => ({
    title: 'Switch current accounts',
    headerColorOutputRange: [
        colors.background.dark,
        colors.cards.onDark,
    ],
}));
const Card = ({ item, onPressMoreDetails, onGetOffer, }) => {
    const { image, title, subtitle, benefits } = item;
    const styles = useStyles(cardStyleSet);
    return (<CardView withPadding noMarginBottom>
      <View style={styles.container}>
        <Logo R44 uri={image} resizeMode="contain"/>
        <Spacer.W16 />
        <View style={styles.flex1}>
          <Text Text-16>{title}</Text>
          <Text TextThin-14 Secondary>
            {subtitle}
          </Text>
        </View>
      </View>
      <Spacer.H16 />
      <View style={styles.benefitsContainer}>
        {benefits.map((benefit, index) => (<View key={benefit.title} style={[
                styles.benefitItem,
                index !== benefits.length - 1 && styles.benefitItemSeparator,
            ]}>
            <Text Numbers-16 centered>
              {benefit.title}
            </Text>
            <Text TextThin-12 Secondary centered>
              {benefit.subtitle}
            </Text>
          </View>))}
      </View>
      <Spacer.H16 />
      <View style={styles.buttonContainer}>
        <Button title="More details" brandReversed square flex onPress={onPressMoreDetails}/>
        <Spacer.W8 />
        <Button title="Go to website" brand square flex onPress={onGetOffer}/>
      </View>
    </CardView>);
};
const cardStyleSet = createStyleSheets((colors) => ({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    benefitsContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginVertical: rem(8),
    },
    benefitItem: {
        flex: 1,
        alignItems: 'center',
    },
    benefitItemSeparator: {
        height: '100%',
        borderRightWidth: 1,
        borderRightColor: colors.borders.divider,
    },
    buttonContainer: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    flex1: {
        flex: 1,
    },
}));
export default CurrentAccountSwitchOffers;
